import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { TranslateModule } from "@ngx-translate/core";
import { PbxOverviewComponent } from "./pbx-overview.component";
import { InboundCallingActivityComponent } from "./inboundCallingActivity/inbound-calling-activity.component";
import { PbxOverviewRoutingModule } from "./pbx-overview-routing.module";
import { HeaderModule } from "../../shared/components/layout/header/header.module";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatSelectModule } from "@angular/material/select";
import { ReactiveFormsModule } from "@angular/forms";
import { MatCardModule } from "@angular/material/card";
import { ChartingDonutGraphModule } from "./charts/donutGraph/donut-graph.module";
import { ChartingBarGraphModule } from "./charts/barGraph/bar-graph.module";
import { ChartingLineGraphModule } from "./charts/lineGraph/line-graph.module";
import { MatIconModule } from "@angular/material/icon";
import { RouterModule } from "@angular/router";
import { MatButtonModule } from "@angular/material/button";
import { OutboundCallingActivityComponent } from "./outboundCallingActivity/outbound-calling-activity.component";
import { InboundOutboundCallingTrendsComponent } from "./inboundOutboundCallingTrends/inbound-outbound-calling-trends.component";
import { SnackbarModule } from "../../shared/components/snackbar/snackbar.module";
import { MatDividerModule } from "@angular/material/divider";
import { AccountInformationComponent } from "./account-information/account-information.component";
import { LoadingContainerComponent } from "../../shared/components/loadingContainer/loading-container.component";

@NgModule({
  imports: [
    CommonModule,
    PbxOverviewRoutingModule,
    TranslateModule,
    HeaderModule,
    MatFormFieldModule,
    MatButtonModule,
    MatDividerModule,
    MatIconModule,
    MatSelectModule,
    RouterModule,
    ReactiveFormsModule,
    MatCardModule,
    ChartingDonutGraphModule,
    ChartingBarGraphModule,
    ChartingLineGraphModule,
    SnackbarModule,
    LoadingContainerComponent
  ],
  declarations: [
    InboundCallingActivityComponent,
    PbxOverviewComponent,
    OutboundCallingActivityComponent,
    InboundOutboundCallingTrendsComponent,
    AccountInformationComponent
  ]
})
export class PbxOverviewModule {}
